import tableHelper from "../../../resources/tableHelper"
    import chartjs from "chart.js"
    import chartHelper from "../../../resources/chartHelper"

    export default {
        //name: 'chartComponent',
        data() {
            return {
                idChart: '',
                indicatorName: '',
                indicatorsList: [],
                //freqTimeSelected: '',
                /*allData: [],
                freqTimeSelected: ''*/
            }
        },
        props: ['allData','freqTimeSelected'],
        watch: {
            freqTimeSelected: function(val) {
                let vm = this
                vm.renderChartByIndicator(vm.indicatorName,vm)
            }
        },
        created() {
            /*let vm = this
            let idChart = vm.uniqId()
            this.idChart = idChart
            let indicator = vm.indicatorName;
            if (indicator !== 0)
            {
                vm.renderChartByIndicator(indicator, vm)
            }
            */

        },
        mounted() {
            let vm = this
            let idChart = vm.uniqId()
            this.idChart = idChart
            let indicator = vm.indicatorName;

            this.$nextTick(function () {
                if (indicator !== 0)
                {
                    vm.renderChartByIndicator(indicator, vm)
                }
            })
        },
        methods: {
            renderChartByIndicator(indicatorName, vm) {


                let groupedData = this.freqTimeSelected === 'month' ? tableHelper.groupByMonth(this.allData) : tableHelper.groupByWeek(this.allData)

                let groupedDataAvg = tableHelper.averageByIndicator(groupedData)

                // On récupère la liste des indicateurs
                vm.indicatorsList = tableHelper.getIndicatorsList(this.allData)

                if(indicatorName == '')
                {
                    indicatorName = vm.indicatorsList[0].value
                }

                let chartData = tableHelper.getValueDateByIndicator(groupedDataAvg.list, indicatorName)

                let idChart = vm.idChart
                let ctx = document.getElementById(idChart).getContext('2d')

                let config = {
                    type: 'line',
                    data: {
                        datasets: [{
                            label: indicatorName,
                            borderColor: "rgb(255, 159, 64)",
                            // fill: false,
                            data: chartData,
                        }]
                    },
                    options: chartHelper.getOptionsTime(indicatorName, indicatorName)
                }
                new chartjs(ctx, config)
            },
            uniqId() {
                return 'idchart_' + Math.random().toString(36).substr(2, 9);
            },
            changeIndicator: function(event) {
                let vm = this
                let valSelect = event.target.value
                vm.indicatorName = valSelect
                vm.renderChartByIndicator(valSelect, vm)
            }
        },
        computed: {
            /*indicatorsList: function() {
                if(this.indicatorsList) {
                    return this.indicatorsList
                }
            },*/
            /*freqTimeSelected: function() {
                if(this.freqTimeSelected) {
                    return this.freqTimeSelected
                }
            }*/
        },
    }